import axiosClient from "../config/axios.js";

export async function findColoniasByCoincidence(term = "") {
  return (await axiosClient.get(`/carta-porte/colonias/search/${term}`)).data;
}

export async function findColoniasByPostal(codigoPostal, term = "") {
  return (
    await axiosClient.get(
      `/carta-porte/colonias/by-postal/${codigoPostal}/${term}`
    )
  ).data;
}

export async function findMunicipalitiesByCoincidence(term = "") {
  return (await axiosClient.get(`/carta-porte/municipalities/search/${term}`))
    .data;
}

export async function findMunicipalitiesByState(estadoClave, term = "") {
  return (
    await axiosClient.get(
      `/carta-porte/municipalities/by-state/${estadoClave}/${term}`
    )
  ).data;
}

export async function findPermissionTypesByCoincidence(term = "") {
  return (await axiosClient.get(`/carta-porte/permission-types/search/${term}`))
    .data;
}

export async function findAutotransportConfigByCoincidence(term = "") {
  return (
    await axiosClient.get(`/carta-porte/autotransport-config/search/${term}`)
  ).data;
}

export async function findPostalCode(term = "") {
  return (await axiosClient.get(`/carta-porte/codigos-postales/search/${term}`))
    .data;
}

export async function findStates(term = "") {
  return (
    await axiosClient.get(`/carta-porte/states/search/${term}`)
  ).data;
}

export async function findClaveProdServCP(term = "") {
  return (
    await axiosClient.get(`/carta-porte/clave-prod-serv-cp/search/${term}`)
  ).data;
}

//////////////////////////////Carta porte/////////////////////////////////
export async function createCartaPorte(data, razonSocial) {
  const response = await axiosClient.post(`/carta-porte/${razonSocial}`, data);
  return response.data;
}

export async function getStampFileCartaPorte(uuidStamp, razonSocial) {
  const response = await axiosClient.get(`/carta-porte/findFileById-zip/${uuidStamp}/${razonSocial}`);
  return response.data;
}

export async function cancelCartaPorte(id, { motivo, uuidReemplazo, razonSocial }) {
  const response = await axiosClient.put(`/stamped-carta-porte/cancel/${id}`, {
    motivo,
    uuidReemplazo,
    razonSocial,
  });
  return response.data;
}

